__webpack_require__.p = "/Education_Paltform/";